import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Alert
} from '@mui/material';
import {
  Map as MapIcon,
  Directions as DirectionsIcon,
  LocationOn as LocationIcon
} from '@mui/icons-material';
import './MapEmbed.css';

const MapEmbed = () => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [showMap, setShowMap] = useState(false);

  // Mock coordinates for Paris
  const location = {
    address: '123 Avenue du Sport, 75001 Paris, France',
    lat: 48.8566,
    lng: 2.3522
  };

  const handleLoadMap = () => {
    setShowMap(true);
    // Simulate map loading
    setTimeout(() => {
      setMapLoaded(true);
    }, 1000);
  };

  const openInGoogleMaps = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const getDirections = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(location.address)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box className="map-embed">
      <Typography variant="h4" component="h2" className="map-title" gutterBottom>
        Notre localisation
      </Typography>
      
      <Typography variant="body1" className="map-subtitle" sx={{ mb: 3 }}>
        Venez nous rendre visite dans nos bureaux parisiens.
      </Typography>

      <Card className="map-container">
        {!showMap ? (
          <CardContent className="map-placeholder">
            <LocationIcon className="map-placeholder-icon" />
            <Typography variant="h6" className="map-placeholder-title" gutterBottom>
              Carte interactive
            </Typography>
            <Typography variant="body2" className="map-placeholder-text" sx={{ mb: 3 }}>
              Cliquez pour charger la carte et voir notre emplacement exact.
            </Typography>
            <Button
              variant="contained"
              startIcon={<MapIcon />}
              onClick={handleLoadMap}
              className="load-map-btn"
            >
              Charger la carte
            </Button>
          </CardContent>
        ) : (
          <Box className="map-content">
            {!mapLoaded && (
              <Box className="map-loading">
                <Typography variant="body2">Chargement de la carte...</Typography>
              </Box>
            )}
            <iframe
              src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.9916256937595!2d2.3522!3d48.8566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDUxJzI0LjAiTiAywrAyMScwOC4wIkU!5e0!3m2!1sfr!2sfr!4v1234567890123`}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mission Sport Location"
              onLoad={() => setMapLoaded(true)}
            />
          </Box>
        )}
      </Card>

      <Box className="map-actions" sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<MapIcon />}
          onClick={openInGoogleMaps}
          className="map-action-btn"
        >
          Ouvrir dans Google Maps
        </Button>
        <Button
          variant="outlined"
          startIcon={<DirectionsIcon />}
          onClick={getDirections}
          className="map-action-btn"
        >
          Itinéraire
        </Button>
      </Box>

      <Alert severity="info" className="map-info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Accès :</strong> Métro Châtelet-Les Halles (lignes 1, 4, 7, 11, 14) - Sortie Rue de Rivoli
        </Typography>
      </Alert>

      <Card className="address-card" sx={{ mt: 2 }}>
        <CardContent>
          <Typography variant="h6" className="address-title" gutterBottom>
            Adresse complète
          </Typography>
          <Typography variant="body1" className="address-text">
            Mission Sport
          </Typography>
          <Typography variant="body1" className="address-text">
            123 Avenue du Sport
          </Typography>
          <Typography variant="body1" className="address-text">
            75001 Paris, France
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MapEmbed;